import { ApiContextType } from './api-context-types';
import { createContext } from '~commons/use-context-selector';

export const ApiContext = createContext<ApiContextType>({ type: 'NULL' });
